'use strict';

(function () {
  'use strict';

  angular.module('msActivityServices').service('actionPlanSvc', ActionPlanSvc);

  ActionPlanSvc.$inject = ['httpSvc'];

  /* @ngInject */
  function ActionPlanSvc(httpSvc) {
    this.getMyPlan = getMyPlan;
    this.addToPlan = addToPlan;
    this.getActionItem = getActionItem;
    this.removeFromPlan = removeFromPlan;
    /**
     * Get a specific action item by ID
     */
    function getActionItem(actionItemId) {
      return httpSvc.get('/apiproxy/user/actionplan/action/' + actionItemId);
    }
    /**
     * Gets a list of the action items that the user has added to their plan
     */
    function getMyPlan() {
      return httpSvc.get('/apiproxy/user/actionplan/sleep').then(splitOutRelated);
    }
    /**
     * Add a specific action item to the user's plan
     */
    function addToPlan(actionItemId) {
      return httpSvc.post('/apiproxy/user/actionplan/action/' + actionItemId);
    }
    /**
     * Remove a specific action item to the user's plan
     */
    function removeFromPlan(actionItemId) {
      return httpSvc.delete('/apiproxy/user/actionplan/action/' + actionItemId);
    }
    /**
     * This goes through a list of action items and splits out the related activities tips from the regular tips
     */
    function splitOutRelated(actionItems) {
      actionItems.forEach(function (ai) {
        var tips = ai.tips;
        ai.tips = tips.filter(function (t) {
          return t.type !== 'ACTIVITY';
        });
        ai.related = tips.filter(function (t) {
          return t.type === 'ACTIVITY';
        });
      });
      return actionItems;
    }
  }
})();